// Simple token utility for storing auth token in localStorage

const TOKEN_KEY = 'authToken'

const tokenUtil = {
  setToken(token) {
    try {
      localStorage.setItem(TOKEN_KEY, token)
    } catch (e) {
      // fail silently in environments without localStorage
      // or when storage is full
      // eslint-disable-next-line no-console
      console.warn('Failed to set token', e)
    }
  },

  getToken() {
    try {
      return localStorage.getItem(TOKEN_KEY)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Failed to get token', e)
      return null
    }
  },

  removeToken() {
    try {
      localStorage.removeItem(TOKEN_KEY)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Failed to remove token', e)
    }
  },

  isAuthenticated() {
    return Boolean(this.getToken())
  }
}

export default tokenUtil
